module.exports = __webpack_public_path__ + "static/media/logo.709b11f1.svg";